import { QUESTIONS } from "./questions.js";
import { FACTORS } from "./factors.js";
export function scoreBigFive(answers){
  const rawF={N:0,E:0,O:0,A:0,C:0},cntF={N:0,E:0,O:0,A:0,C:0},rawFacet={},cntFacet={};
  QUESTIONS.forEach((q,i)=>{
    const raw=answers[i];if(!raw||raw<1||raw>5)return;
    const scored=q.keyed===-1?(6-raw):raw;
    rawF[q.factor]+=scored;cntF[q.factor]++;
    const key=`${q.factor}_${q.facet}`;rawFacet[key]=(rawFacet[key]||0)+scored;cntFacet[key]=(cntFacet[key]||0)+1;
  });
  const scales={};
  FACTORS.forEach(f=>{const avg=rawF[f.id]/(cntF[f.id]||1);scales[f.id]=Math.max(1,Math.min(10,Math.round((avg-1)/4*9)+1));});
  const facets={};
  Object.entries(rawFacet).forEach(([key,sum])=>{const avg=sum/(cntFacet[key]||1);facets[key]=Math.max(1,Math.min(10,Math.round((avg-1)/4*9)+1));});
  const stability=11-scales["N"];
  const perfAvg=+((scales["C"]+stability)/2).toFixed(1);
  const potAvg=+((scales["O"]+scales["E"])/2).toFixed(1);
  const perfBox=perfAvg<=4?1:perfAvg<=7?2:3,potBox=potAvg<=4?1:potAvg<=7?2:3;
  return{scales,facets,validityFlag:null,perfAvg,potAvg,perfBox,potBox,axes:{x:perfAvg,y:potAvg}};
}
